"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: galleryRef,
    isVisible: galleryVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const projects = [{
    index: "01",
    title: "Midnight Pulse",
    year: "2024",
    location: "London",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_london.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_london.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_london.png-wvc-sizes",
    alt: "The Eclipse performing under magenta strobe lights in London",
    height: "h-[520px] md:h-[640px]",
    featured: true
  }, {
    index: "02",
    title: "Studio Void",
    year: "2023",
    location: "Berlin",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_studio_berlin.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_studio_berlin.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_studio_berlin.png-wvc-sizes",
    alt: "Behind the scenes recording session in a dark studio",
    height: "h-[320px] md:h-[380px]",
    featured: false
  }, {
    index: "03",
    title: "Neon Static",
    year: "2024",
    location: "Tokyo",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_tokyo.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_tokyo.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_tokyo.png-wvc-sizes",
    alt: "High contrast concert shot with electric magenta flares",
    height: "h-[280px] md:h-[340px]",
    featured: false
  }, {
    index: "04",
    title: "Tour Bus Noir",
    year: "2023",
    location: "Europe",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_tour_bus.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_tour_bus.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_tour_bus.png-wvc-sizes",
    alt: "Grainy black and white shot of tour life on the road",
    height: "h-[440px] md:h-[520px]",
    featured: false
  }, {
    index: "05",
    title: "Celestial Stage",
    year: "2024",
    location: "Paris",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_paris.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_paris.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_paris.png-wvc-sizes",
    alt: "The Eclipse silhouetted against a massive circular light rig",
    height: "h-[560px] md:h-[680px]",
    featured: true
  }, {
    index: "06",
    title: "Lyric Sheets",
    year: "2022",
    location: "Stockholm",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_lyrics_process.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_lyrics_process.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_lyrics_process.png-wvc-sizes",
    alt: "Handwritten lyrics on a desk with a single spotlight",
    height: "h-[300px] md:h-[360px]",
    featured: false
  }, {
    index: "07",
    title: "Backstage Echo",
    year: "2023",
    location: "Milan",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_backstage_milan.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_backstage_milan.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_backstage_milan.png-wvc-sizes",
    alt: "Candid moment backstage before the show starts",
    height: "h-[360px] md:h-[440px]",
    featured: false
  }, {
    index: "08",
    title: "Electric Night",
    year: "2024",
    location: "New York",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_nyc.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_nyc.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_live_nyc.png-wvc-sizes",
    alt: "Crowd hands reaching toward magenta stage lights",
    height: "h-[480px] md:h-[580px]",
    featured: false
  }, {
    index: "09",
    title: "The Rehearsal",
    year: "2023",
    location: "London",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_rehearsal_london.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_rehearsal_london.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_rehearsal_london.png-wvc-sizes",
    alt: "The Eclipse practicing choreography in a warehouse",
    height: "h-[540px] md:h-[660px]",
    featured: true
  }, {
    index: "10",
    title: "Sound Check",
    year: "2022",
    location: "Madrid",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_soundcheck.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_soundcheck.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_soundcheck.png-wvc-sizes",
    alt: "Empty venue during afternoon sound check",
    height: "h-[300px] md:h-[360px]",
    featured: false
  }, {
    index: "11",
    title: "After Hours",
    year: "2024",
    location: "Barcelona",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_afterparty.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_afterparty.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_afterparty.png-wvc-sizes",
    alt: "Moody blue-lit afterparty atmosphere",
    height: "h-[420px] md:h-[500px]",
    featured: false
  }, {
    index: "12",
    title: "Vinyl Press",
    year: "2023",
    location: "London",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_vinyl_production.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_vinyl_production.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_vinyl_production.png-wvc-sizes",
    alt: "Close up of magenta vinyl records being pressed",
    height: "h-[340px] md:h-[400px]",
    featured: false
  }];
  const diamondPlate = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='14' viewBox='0 0 28 14'><path d='M0 7 L7 0 L14 7 L7 14 Z M14 7 L21 0 L28 7 L21 14 Z' fill='none' stroke='%23320032' stroke-width='1'/></svg>\")";
  return <section data-section-id="1745" id="live-unfiltered" className="bg-background text-foreground font-default">
      {}
      <div aria-hidden="true" className="w-full h-[14px]" style={{
      backgroundImage: diamondPlate,
      backgroundRepeat: "repeat",
      backgroundSize: "28px 14px"
    }} />

      <div className="px-6 md:px-10 lg:px-16 py-24 md:py-36 max-w-[1440px] mx-auto">
        {}
        <div ref={headerRef} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-24">
          {}
          <div className={`lg:col-span-7 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-6 md:mb-8">
              <span className="font-mono text-[0.6875rem] md:text-[0.8125rem] font-medium uppercase tracking-[0.2em] text-muted-foreground">
                LAT: 51.5074 / LON: 0.1278
              </span>
              <span aria-hidden="true" className="inline-block w-2 h-2" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span className="font-mono text-[0.6875rem] md:text-[0.8125rem] font-medium uppercase tracking-[0.2em] text-muted-foreground">
                LIVE & UNFILTERED
              </span>
            </div>

            {}
            <h2 className="font-default font-extrabold uppercase leading-[0.9] tracking-tighter text-foreground" style={{
            fontSize: "clamp(2.25rem, 4.8vw, 4.75rem)"
          }}>
              <span className="block">Moments,</span>
              <span className="block">
                Not{" "}
                <span className="relative inline-block">
                  <span className="relative z-10">Staged</span>
                  <svg aria-hidden="true" className={`absolute left-[-4%] top-1/2 -translate-y-1/2 w-[108%] h-[1.2em] pointer-events-none transition-all duration-700 ease-out ${headerVisible ? "opacity-100" : "opacity-0"}`} viewBox="0 0 100 20" preserveAspectRatio="none">
                    <line x1="0" y1="16" x2="100" y2="4" stroke="var(--primary)" strokeWidth="6" strokeLinecap="square" style={{
                    strokeDasharray: 110,
                    strokeDashoffset: headerVisible ? 0 : 110,
                    transition: "stroke-dashoffset 700ms cubic-bezier(0.16, 1, 0.3, 1) 400ms"
                  }} />
                  </svg>
                </span>
              </span>
            </h2>
          </div>

          {}
          <div className={`lg:col-span-5 flex flex-col justify-end transition-all duration-700 ease-out delay-150 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-default text-muted-foreground max-w-[380px] mb-6 md:mb-8 leading-[1.6]" style={{
            fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)"
          }}>
              Raw energy captured in the heat of the performance. From sold-out arenas to the quiet intensity of the studio, this is the visual pulse of The Eclipse.
            </p>
            <Link to="/EclipsePage" className="group inline-flex items-center gap-2 font-default font-semibold text-foreground w-fit">
              <span className="relative font-mono text-sm uppercase tracking-[0.2em]">
                Download EPK
                <span aria-hidden="true" className="absolute left-0 -bottom-1 h-[2px] w-full origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-[250ms] ease-out" style={{
                backgroundColor: "var(--primary)"
              }} />
              </span>
              <ArrowRight className="size-4 transition-transform duration-220 ease-out group-hover:translate-x-1.5 text-primary" strokeWidth={1.75} />
            </Link>
          </div>
        </div>

        {}
        <div ref={galleryRef} className="columns-2 lg:columns-4 gap-3 [column-fill:_balance]">
          {projects.map((project, i) => <div key={project.index} data-index={i} className={`group relative mb-3 break-inside-avoid overflow-hidden cursor-pointer transition-all duration-700 ease-out ${galleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: galleryVisible ? `${i * 60}ms` : "0ms"
        }}>
              {}
              <div className={`relative w-full ${project.height} overflow-hidden bg-card`}>
                <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04] mix-blend-screen" />

                {}
                {project.featured && <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-1 z-20" style={{
              backgroundColor: "var(--primary)"
            }} />}

                {}
                <div aria-hidden="true" className="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full transition-all duration-500 ease-out z-20" style={{
              backgroundColor: "var(--primary)"
            }} />

                {}
                <span aria-hidden="true" className="absolute top-2 left-2 w-6 h-6 opacity-0 group-hover:opacity-100 transition-opacity duration-220 z-10" style={{
              borderTop: "1px solid var(--primary)",
              borderLeft: "1px solid var(--primary)"
            }} />
                <span aria-hidden="true" className="absolute top-2 right-2 w-6 h-6 opacity-0 group-hover:opacity-100 transition-opacity duration-220 z-10" style={{
              borderTop: "1px solid var(--primary)",
              borderRight: "1px solid var(--primary)"
            }} />
                <span aria-hidden="true" className="absolute bottom-2 left-2 w-6 h-6 opacity-0 group-hover:opacity-100 transition-opacity duration-220 z-10" style={{
              borderBottom: "1px solid var(--primary)",
              borderLeft: "1px solid var(--primary)"
            }} />
                <span aria-hidden="true" className="absolute bottom-2 right-2 w-6 h-6 opacity-0 group-hover:opacity-100 transition-opacity duration-220 z-10" style={{
              borderBottom: "1px solid var(--primary)",
              borderRight: "1px solid var(--primary)"
            }} />

                {}
                <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-1/3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
              background: "linear-gradient(to top, hsl(240 30% 2% / 0.9) 0%, hsl(240 30% 2% / 0) 100%)"
            }} />

                {}
                <div className="absolute bottom-3 left-3 right-3 translate-y-2 group-hover:translate-y-0 transition-transform duration-300 ease-out z-10">
                  <p className="font-mono text-[0.7rem] md:text-xs uppercase tracking-[0.2em] leading-tight text-foreground">
                    {project.index} / {project.title} / {project.year}
                  </p>
                  <p className="font-mono text-[0.65rem] md:text-[0.7rem] uppercase tracking-[0.2em] mt-1 text-primary">
                    ▸ {project.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-12 md:mt-16 flex justify-center lg:hidden">
          <Button asChild className="h-14 px-8 font-default font-extrabold uppercase tracking-[0.06em] rounded-md shadow-md" style={{
          backgroundColor: "var(--primary)",
          color: "var(--primary-foreground)"
        }}>
            <Link to="/EclipsePage" className="inline-flex items-center gap-2">
              Download EPK
              <ArrowRight className="size-4" strokeWidth={2} />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div aria-hidden="true" className="w-full h-[14px]" style={{
      backgroundImage: diamondPlate,
      backgroundRepeat: "repeat",
      backgroundSize: "28px 14px"
    }} />
    </section>;
}